module.exports = __webpack_public_path__ + "static/media/personNewKTM.0158b679.svg";